
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import getFullAddressString from '@ancon/wildcat-utils/user/getFullAddressString';
import { OrderFormat } from '@ancon/wildcat-types';
import Page from '../../../features/layout/components/Page';
import { fetchOutletListItem } from '../../../features/outlet/store/outletThunks';
import useAppSelector from '../../../store/hooks/useAppSelector';
import { outletDetailsSelector, outletFiltersSelector, outletIsVisibleServiceTimeKindSelectionModalSelector, outletListItemSelector, } from '../../../features/outlet/store/outletSelector';
import getAppServerSideProps from '../../../store/ssr/getAppServerSideProps';
import OutletDetailsHeader from '../../../features/outlet/components/OutletDetailsHeader';
import OrderConfigurationModal from '../../../features/outlet/components/orderConfigurationModal/OrderConfigurationModal';
import NavbarOutletSearch from '../../../features/layout/components/main/navBar/NavbarOutletSearch';
import NavbarOrderFormatFilter from '../../../features/layout/components/main/navBar/NavbarOrderFormatFilter';
import useAppDispatch from '../../../store/hooks/useAppDispatch';
import OutletMenu from '../../../features/outlet/components/outletMenu/OutletMenu';
import OutletChangeWarningModal from '../../../features/outlet/components/OutletChangeWarningModal';
import OutletDetailsModal from '../../../features/outlet/components/outletDetailsModal/OutletDetailsModal';
import ClientAuthContainer from '../../../features/auth/components/ClientAuthContainer';
import TableOrderingFilter from '../../../features/outlet/components/TableOrderingFilter';
import OutletMenuSkeleton from '../../../features/outlet/components/outletMenu/OutletMenuSkeleton';
import { outletSetIsVisibleDeliveryLocationModal, outletSetIsVisibleServiceTimeKindSelectionModal, outletSetOutletFilters, } from '../../../features/outlet/store/outletSlice';
import useAppStore from '../../../store/hooks/useAppStore';
import { checkoutFiltersSelector, checkoutIsWalletTopUpSelector, outletSelectedOutletHasCheckoutSelector, } from '../../../features/checkout/store/checkoutSelectors';
import NavBarOrderTimeSwitch from '../../../features/layout/components/main/navBar/NavBarOrderTimeSwitch';
import NewOrderTimeConfigureModal from '../../../features/outlets/components/newOrderTimeConfigureModal/NewOrderTimeConfigureModal';
import isAppWhiteLabeled from '../../../features/app/utils/isAppWhiteLabeled';
import { clientContextIsCompanyUserSelector } from '../../../features/clientContext/store/clientContextSelectors';
import WalletCheckoutWarningModal from '../../../features/wallets/components/WalletCheckoutWarningModal';
import { WalletCheckoutWarningType } from '../../../features/wallets/types';
import OutletDetailsURLFilter from '../../../features/outlet/components/OutletDetailsURLFilter';
import styles from './index.module.scss';
interface OutletPageQuery {
    outletSlug?: string;
}
function OutletDetailsPage() {
    const dispatch = useAppDispatch();
    const store = useAppStore();
    const outlet = useAppSelector(outletListItemSelector);
    const outletFilter = useAppSelector(outletFiltersSelector);
    const outletDetails = useAppSelector(outletDetailsSelector);
    const isCompanyUser = useAppSelector(clientContextIsCompanyUserSelector);
    const isWhiteLabeled = isAppWhiteLabeled();
    const isCompanyDashboard = !!isCompanyUser && isWhiteLabeled;
    const [shouldDeliveryLocationModalOpen, setShouldDeliveryLocationModalOpen] = useState(true);
    const outletHasCheckout = useAppSelector(outletSelectedOutletHasCheckoutSelector);
    const isWalletTopUpCheckout = useAppSelector(checkoutIsWalletTopUpSelector);
    const isVisibleServiceTimeKindSelectionModal = useAppSelector(outletIsVisibleServiceTimeKindSelectionModalSelector);
    const { name, logoId, address } = outlet || {};
    // Open delivery location modal for delivery order format
    useEffect(() => {
        if (shouldDeliveryLocationModalOpen &&
            outlet &&
            !outletFilter.delivery &&
            outletFilter.orderFormat === OrderFormat.Delivery) {
            dispatch(outletSetIsVisibleDeliveryLocationModal(true));
            setShouldDeliveryLocationModalOpen(false);
        }
        if (outletFilter.orderFormat !== OrderFormat.Delivery &&
            shouldDeliveryLocationModalOpen) {
            setShouldDeliveryLocationModalOpen(false);
        }
    }, [
        shouldDeliveryLocationModalOpen,
        dispatch,
        outlet,
        outletDetails?.id,
        outletFilter.delivery,
        outletFilter.orderFormat,
    ]);
    useEffect(() => {
        if (outletHasCheckout && !isWalletTopUpCheckout) {
            const checkoutFilters = checkoutFiltersSelector(store.getState());
            dispatch(outletSetOutletFilters(checkoutFilters));
        }
    }, [dispatch, isWalletTopUpCheckout, outletHasCheckout, store]);
    function handleOnCloseServiceTimeKindSelectionModal() {
        dispatch(outletSetIsVisibleServiceTimeKindSelectionModal(false));
    }
    return (<Page description={getFullAddressString(address)} title={name} imageId={logoId}>
      {outlet && (<>
          <div className={styles.actionButtons}>
            {!isCompanyDashboard && <NavbarOutletSearch isInNavBar={false}/>}
            <div className={styles.actionButtonsGroup}>
              <NavbarOrderFormatFilter isInNavBar={false}/>
              <NavBarOrderTimeSwitch isInNavBar={false}/>
            </div>
          </div>
          <OutletDetailsHeader />
          <ClientAuthContainer skeleton={<OutletMenuSkeleton />}>
            <OutletMenu />
            <OrderConfigurationModal />
            <OutletChangeWarningModal />
            <WalletCheckoutWarningModal type={WalletCheckoutWarningType.AddProducts}/>
            <TableOrderingFilter />
            <OutletDetailsURLFilter />
            <OutletDetailsModal />
            {outletFilter?.orderFormat && (<NewOrderTimeConfigureModal selectedOrderFormat={outletFilter?.orderFormat} isOpen={isVisibleServiceTimeKindSelectionModal} onClose={handleOnCloseServiceTimeKindSelectionModal}/>)}
          </ClientAuthContainer>
        </>)}
    </Page>);
}
const getServerSideProps = getAppServerSideProps(async ({ store, nextCtx }) => {
    const query = nextCtx.query as OutletPageQuery;
    const response = await store
        .dispatch(fetchOutletListItem({ urlSlug: query?.outletSlug }))
        .unwrap();
    // if outlet not found, redirect to landing page
    if (!response) {
        return {
            redirect: {
                destination: '/',
                permanent: false,
            },
        };
    }
    return {
        props: {} as never,
    };
});
export default OutletDetailsPage;

    async function __Next_Translate__getServerSideProps__1973414e3e6__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/outlet/[outletSlug]/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1973414e3e6__ as getServerSideProps }
  